import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconMovie } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface MovieListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const MovieListItem: React.FC<MovieListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconMovie}
    typeLabel="Movie"
    testId="movie-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.WATCH }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default MovieListItem
